import client from '.spat/modules/client';
import app from './scripts/app';
import './scripts/riot_mixin'

// client.showSSR();

// 起動時の store.watch を待つ上限
const SETUP_TIMEOUT_MS = 15000;

app.useragent = useragent.parse(navigator.userAgent);
dayjs.locale('ja');

// setup firestore
app.store.init(firebase.firestore());
app.store.settings({
  merge: true,
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
});

// setup firebase auth
app.auth.on('ready', async (user) => {
  app.hypermdLoader.load();
  // 失敗しても client.start() まで進める(止まると SSR が透明のままで真っ白になる)
  let setup_error = null;
  if (user) {
    // sign_in は描画に使われない（ノート本文は Firestore 取得）ため待たない。
    // ready は永続セッションの復帰なのでユーザー doc・claims は既に存在し、
    // 描画に必要なのは store.watch() だけ。sign_in を待つと client.start() が
    // ブロックされ FCP が sign_in 完了まで遅延するため、並列で投げて結果は then で受ける。
    app.api.child('me/sign_in').post({}).then(({ user: _user }) => {
      app.utils.openModalNameSettingIfNeeded(_user);
    }).catch(console.error);

    try {
      await app.utils.withTimeout(app.store.watch(), SETUP_TIMEOUT_MS);

      // web push通知の許可を求める
      app.webpush.requestPermissionIfNeeded();

      capacitor.setupPushNotifications();
    }
    catch (e) {
      // タイムアウトは回線が遅いだけなのでエラーにしない(各ページの store.setup() が続きを待つ)
      if (e.isTimeout) {
        console.warn(e);
      }
      else {
        setup_error = e;
      }
    }
  }

  // TODO: spat に実装されたら消す
  if (!spat.router.replaceState) {
    spat.router.replaceState = function(path) {
      history.replaceState({
        ...history.state,
        pageIndex: this.pageIndex,
      }, '', path);
    };
  }

  // 未ログインの場合、公開ページ以外はsigninにリダイレクトする
  if (!user) {
    const PUBLIC_PATHS = ['/signin', '/signup', '/password-reset', '/invites', '/faq'];
    if (!PUBLIC_PATHS.includes(location.pathname)) {
      let redirect = location.pathname + location.search;
      let signin_path = redirect === '/' ? '/signin' : '/signin?redirect=' + encodeURIComponent(redirect);
      spat.router.replaceState(signin_path);
    }
  }

  // ソフトウェアキーボードの監視
  app.utils.setupInputFocusChange();
  // キーボードショートカットのセットアップ
  app.shortcut.setup();
  client.start();

  // popup のセットアップ
  const $popup = document.createElement('div');
  spat.appTag.root.appendChild($popup);
  const popupTag = riot.mount($popup, 'module-popup')[0];
  spat.appTag.popupTag = popupTag;
  spat.popup = popupTag;

  // tooltip のセットアップ
  const $tooltip = document.createElement('div');
  spat.appTag.root.appendChild($tooltip);
  const tooltipTag = riot.mount($tooltip, 'module-tooltip')[0];
  spat.appTag.tooltipTag = tooltipTag;
  spat.tooltip = tooltipTag;

  if (setup_error) {
    app.utils.confirmReload(setup_error);
  }

  // ウェブのときしか呼ばない
  if (!capacitor.isAvailable && location.hostname !== 'localhost' && spat.config.env === 'production') {
    // PWA 対応
    if ('serviceWorker' in navigator) {
      // parcel のビルドでファイル検知しようとしてエラーが出るので + で結合
      navigator.serviceWorker.register('/sw.' + 'js');
    }
    // web 通知対応
    app.webpush.setup();
    app.webpush.setupClient();
  }

  // ローカルストレージにあるノートコメントの履歴をセットする
  app.utils.storage.noteComment.setup();
});

app.auth.on('signin', async (e) => {

  // invite_id があった場合は sign_in に渡す
  let invite_id = '';
  const url = new URL(location.href);
  if (url.searchParams.has('invite')) {
    invite_id = url.searchParams.get('invite');
  }

  // 必ず sign in API を実行しておく(ここで firestore 上にユーザーが作られる)
  let { user } = await app.api.child('me/sign_in').post({invite_id});

  // 監視をスタート
  await app.store.watch();
  app.utils.openModalNameSettingIfNeeded(user);
  // web push通知の許可を求める
  app.webpush.requestPermissionIfNeeded();

  // NATIVE: プッシュ通知のセットアップ
  capacitor.setupPushNotifications();

  // signin/signup ページだった場合はリダイレクトさせる
  if (['/signin', '/signup'].includes(location.pathname)) {
    let params = new URLSearchParams(location.search);
    let redirect = params.get('redirect');
    spat.router.replace(redirect || '/');
  }
});

app.auth.on('signout', () => {
  app.store.unwatch();
  // ローカルストレージに保存している書きかけコメントの情報を削除する
  app.utils.storage.noteComment.deleteAll();
  // クリップしたノートの情報を削除する
  app.utils.clip.clear();
});

app.auth.init(firebase);


// for capacitor
capacitor.enableSwipeBack();
